(function () {
  'use strict';
  angular.module('cbl.finanza.mf.directives').directive('finDossierChartPane', [
    'FinDossierChartPaneSrvc',
    'CommonUtilitiesSrvc',
    'FIN_CONSTANTS',
    function (finDossierChartPaneSrvc, commonUtilities, CONSTANTS) {
      var directiveImpl = function ($scope) {
        $scope.service = finDossierChartPaneSrvc;
        $scope.commonUtilities = commonUtilities;

        $scope.startDateRequired = false;
        $scope.startDate = null;
        $scope.endDateRequired = false;
        $scope.endDate = null;

        $scope.getGraficoSaldoDossier = function () {
          $scope.startDateRequired = isNaN(Date.parse($scope.startDate));
          $scope.endDateRequired = isNaN(Date.parse($scope.endDate));

          if ($scope.startDateRequired || $scope.endDateRequired) {
            return;
          }
          
          $scope.service.chartDatasource = new Array();
          var serviceUrl = CONSTANTS.REST_ROOT +
          CONSTANTS.REST.CHART +
          '/' +
          $scope.rapporto;
          var serviceParams = {
            dataDa: new Date($scope.startDate).toISOString().substring(0,10),
            dataA: new Date($scope.endDate).toISOString().substring(0,10)
          };
          var parentThis = $scope;
          var successCallback = function (self, data) {
            data.result.forEach(function (element, index, array) {
              var datasource = [];
              var date = new Date(element.data);
              var y = element.saldo;

              var chartPoint = [];
              chartPoint.push(
                Date.UTC(
                  date.getFullYear(),
                  date.getMonth(),
                  date.getDate(),
                  date.getHours(),
                  date.getMinutes(),
                  date.getSeconds()
                )
              );
              chartPoint.push(y);
              self.service.chartDatasource.push(chartPoint);
            });
          };
          var showLoaderService = 'Caricamento in corso...';
          $scope.commonUtilities.executeHttpGetService(
            serviceUrl,
            serviceParams,
            parentThis,
            showLoaderService,
            successCallback,
            null
          );
        };

        $scope.resetGraficoSaldoDossier = function () {
          $scope.startDate = null;
          $scope.endDate = null;
          $scope.service.chartDatasource = new Array();
        };
      };
      directiveImpl.$inject = ['$scope'];

      return {
        restrict: 'E',
        require: 'ngModel',
        scope: {
          rapporto: '=?ngModel'
        },
        templateUrl:
          CONSTANTS.BASE_ROOT +
          'widgets/finDossierChartPane/finDossierChartPane.html',
        replace: false,
        controller: directiveImpl
      };
    }
  ]);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finDossierChartPane/finDossierChartPaneDrct.js
 ** module id = 36
 ** module chunks = 1 2
 **/